import {noop} from '@benchling/js-utils';
import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import {Registry} from 'constants/RegistryConstants';
import {ModalPane} from 'constants/SampleConstants';
import {ActionOrigin} from 'graphql-client/__generated/graphqlGlobalTypes';
import * as ModalContainer from 'ui-library/ModalContainer';

import {LocationSummaryGraphQL} from '../../graphql-fragments/inventory/__generated/LocationSummaryGraphQL';
import CreatePlatePane from './CreatePlatePane';
import CreateStorableModal from './CreateStorableModal';
import {CreateGridPaneState} from './grids/getCreateGridParams';
import * as StorableActions from './StorableActions';

interface CreatePlateModalProps {
  onRequestClose?: () => void;
  initialParentStorable?: LocationSummaryGraphQL | null;
  initialRegistry: Registry | null;
  actionOrigin: ActionOrigin;
}

class CreatePlateModal extends React.Component<CreatePlateModalProps> {
  static open = (props: CreatePlateModalProps): void => {
    ModalContainer.open(
      CreatePlateModal,
      <CreatePlateModal {...props} onRequestClose={CreatePlateModal.close} />
    );
  };

  static close = (): void => {
    ModalContainer.close(CreatePlateModal);
  };

  private handleCreatePlate = (
    onFinish: (errorMessage?: string) => void,
    _createPropsArray: undefined,
    paneState: CreateGridPaneState
  ): void => {
    StorableActions.createPlate(paneState, onFinish);
  };

  render(): JSX.Element {
    return (
      <CreateStorableModal
        initialParentStorable={this.props.initialParentStorable ?? null}
        initialRegistry={this.props.initialRegistry}
        isParentStorableRequired={BenchlingConfig.ENABLE_REQUIRED_PARENT_STORABLE}
        modalPane={ModalPane.CREATE_PLATE}
        onCreate={this.handleCreatePlate}
        onRequestClose={this.props.onRequestClose ?? noop}
        paneClass={CreatePlatePane}
        analyticsMetadata={{actionOrigin: this.props.actionOrigin}}
      />
    );
  }
}

export default CreatePlateModal;
